import React from "react";

const FooterSection = () => {
  return (
    <footer className="snap-start bg-slate-900 text-white py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div>
            <div className="inline-flex items-center bg-white rounded p-1">
              <img
                src="/logo-emergency-qr.png?v=4"
                alt="Emergency QR by Ditya Technologies"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-slate-400 mt-4 leading-relaxed">
              Simple products that help people stay safe. Built in India, for Indian families.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Products</h4>
            <ul className="space-y-2 text-slate-400">
              <li>Emergency QR Code Sticker</li>
              <li>Premium Metallic Locket (Coming Soon)</li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Get in Touch</h4>
            <p className="text-slate-400">Email: contact@dityatechnologies.in</p>
            <p className="text-slate-500 text-sm mt-2">We typically respond within 24 hours</p>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-6 pt-6 text-center text-slate-500">
          <p>&copy; {new Date().getFullYear()} Ditya Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
